
import React from 'react'
import LxHeader from '@/components/LxHeader/One'
import { Anchor } from 'antd'
// import { Link } from 'react-router-dom'
import styles from './index.module.scss'
// import defaultSetting from '@/setting'
// import { getUrlParams } from '@/utils/util'
// import { companyList } from '@/constants/companyInfo'
// const sz_default_url = `/${defaultSetting.suiteKey}/pb/social.html`
// const xz_default_url = `/${defaultSetting.suiteKey}/pb/school.html`
const problem = require('@/assets/images/positionList/problem.png')

class PositionList extends React.Component {
    constructor(props){
        super(props);
        this.state = {
           leftTitleArr:[{
            title:"通用问题",
            id:1,
           },{
            title:"校园招聘",
            id:2,
           },{
            title:"社会招聘",
            id:3,
           },{
            title:"内推问题",
            id:4,
           }],

           rightProblemArr :[
            {
                id:1,
                problemList:[
                    {
                        title:'忘记官网登录密码如何处理？',
                        answer:'如果还记得注册账号时用的邮箱，可点击“忘记密码”进行重置；如果已忘记，只能重新注册'
                    },
                    {
                        title:'如何投递简历和申请职位？',
                        answer:'登录账号后，在“个人中心—新建简历”/“简历管理”中完善简历，查看不同招聘版块下的职位，点击“投递此职位”'
                    },
                    {
                        title:'是否可申请多个公司的职位或同一公司的不同职位？最多可申请几个？',
                        answer:'社会招聘中，候选人可投递多个公司、多个职位，每个职位仅能投递一次。校园招聘中，候选人可以投递多个公司的职位，同一公司只能申请一个职位'
                    },
                    {
                        title:'如何确定简历投递成功了，怎么查询自己的招聘进度？',
                        answer:'选择职位并点击“投递此职位”后，页面会显示投递结果。也可以通过以下方式查看招聘进度： <br> 1）PC端登录“中国一汽招聘”官网，在“个人中心—投递记录”中查看招聘进度  <br>2）移动端进入“中国一汽招聘”公众号，点击“我要应聘”，在“个人中心—已投递职位”中看到招聘进度 '
                    },
                    {
                        title:'如何修改已申请职位，是否有修改时限？',
                        answer:'已投递简历还处于待处理状态时，可以修改投递职位，如已进入后续流程，则不能修改，可在本次招聘流程结束后，再次申请职位'
                    },
                    {
                        title:'如何修改简历中的联系邮箱/手机号？',
                        answer:'简历刚投递还处于待处理状态时，允许修改联系方式，如已进入后续流程，则只能联系招聘人员从后台修改联系方式'
                    },
                    {
                        title:'在简历注册、视频录制、测评填写过程中如遇到其他问题该如何处理？',
                        answer:'“中国一汽招聘”官方微信公众号后台留言，您在提出问题时请备注姓名、投递职位及个人联系方式，方便我们及时与您取得联系'
                    },
                    {
                        title:'公司员工福利是怎样的？',
                        answer:`1）六险二金、采暖补贴、通讯补贴等 
                        <br>
                                2）健康体检、工作餐、通勤班车、员工购车、四季工装、职工公寓等
                                <br>
                               3）带薪年假、探亲假、厂休假、工会福利、节日福利、生日福利等
                               <br>`
                    },
                    {
                        title:'公司接收档案、党组织关系吗？',
                        answer:`公司接收档案、党组织关系。社招新员工可在收到的offer中查看办理流程，校招新员工在完成三方协议签约后，会收到HR发送的办理流程说明`
                    },
                ]
            },
            {
                id:2,
                problemList:[
                    {
                        title:'参加工作后是否有机会调整工作地点？',
                        answer:'入职后可以通过OA了解集团公司及各单位内部招聘规则及岗位需求'
                    },
                    {
                        title:'已在现场投递了简历是否还需要网申？',
                        answer:'是的，网申是必要流程，所有人都需要参加。招聘流程完全依托于线上系统，包括已经投递纸质简历的同学必须在线上申请'
                    },
                    {
                        title:'中国一汽校园招聘主要有哪些专业？',
                        answer:'中国一汽岗位覆盖机械、车辆、材料、计算机、软件工程、通信等多个专业，只要大家在招聘官网上可以看到的专业都是本次招聘的需求专业'
                    },
                    {
                        title:'岗位投递志愿顺序是否影响应聘结果？',
                        answer:'中国一汽校园招聘每人投递的多个志愿为平行志愿，投递顺序不影响应聘结果'
                    },
                    {
                        title:'校园招聘的流程和周期是怎么安排的？',
                        answer:`具体流程：简历投递-简历筛选-在线测评-面试-发放offer-签约-背景调查-体检-入职`
                    },
                    {
                        title:'如未参加宣讲会，是否可以参加面试？',
                        answer:'当然可以！只要网上投递就都有机会参与面试，请经常留意当前显示的简历状态'
                    },
                    {
                        title:'除官网公布的行程外，是否会有其他宣讲会安排？',
                        answer:'请关注“中国一汽招聘”微信公众号和校内就业信息网发布的信息'
                    },
                    {
                        title:'秋招没有通过是否可以参加春招？',
                        answer:'可以参加'
                    },
                    // {
                    //     title:'如果未参加宣讲会，是否可以参加面试？',
                    //     answer:`可以参加`
                    // },
                    {
                        title:'来公司后有哪些的培训机会？',
                        answer:'新员工在入职后将经历公司介绍等入职培训，生产制造工艺学习等车间实习，时间管理等基础通用能力培训以及根据岗位需求而开展的专业知识学习。同时有很多外出培训的机会'
                    },
                    {
                        title:'户口是否需要迁往中国第一汽车集团有限公司？',
                        answer:'一汽对户口是否迁移不做强制要求，但不转户口可能影响到后续购房、购车等事宜，具体情况需参考各工作地地方政策'
                    },
                ]
            },
            {
                id:3,
                problemList:[
                    {
                        title:'社会招聘的流程怎么安排的？',
                        answer:'社会招聘包括简历初筛-测评-简历复筛-面试-谈薪-体检-背调-offer几个环节，一般面试后1周内，我们会进行反馈'
                    },
                    {
                        title:'社会招聘对工作年限要求？',
                        answer:'社会招聘一般要求至少具有36个月岗位相关工作经验'
                    },
                ]
            },
            {
                id:4,
                problemList:[
                    {
                        title:'员工如何获取内推职位？',
                        answer:'可以进入PC端“中国一汽招聘”官网、移动端“中国一汽招聘”公众号的“员工内推”版块，同时可以在“一汽EASY”平台的“工作台-云举荐”获取职位信息'
                    },
                    {
                        title:'忘记官网登录密码如何处理？',
                        answer:'如果还记得注册账号时用的邮箱，可点击“忘记密码”进行重置；如果已忘记，只能重新注册'
                    },
                    {
                        title:'员工如何推荐人选？',
                        answer:'可在“员工内推”版块中，选择职位，点击“推荐”并上传简历；或点击“分享”，将职位信息分享给被推荐人，由被推荐人上传简历'
                    },
                    {
                        title:'员工如何获取招聘进度信息？',
                        answer:'在“员工内推”版块完成登录后，可以在“推荐记录”中查看招聘进度'
                    },
                    // {
                    //     title:'内推奖金如何发放？',
                    //     answer:'一般同工资一同发放，具体以各单位员工内推相关管理办法为准'
                    // },
                    {
                        title:'内推政策是怎样的？',
                        answer:'在“员工内推”版块完成登录后，可以在“内推政策”中查看'
                    },
                    {
                        title:'内推简历时，为什么提示“推荐失败，相同部门职位下简历重复”？',
                        answer:'当同一个部门下的职位中已有候选人简历，系统会提示推荐失败，可尝试推荐其他部门岗位'
                    },
                ]
            },
           ],

           currentIndex:1,


        }
    }

    // 折叠面板操作
    changeTabsIndex = (key) => {
        this.setState({
            currentIndex: key
        })
    }

    // 获取筛选参数
    getScreenData = (type, code) => {
        let {screenData} = this.state;

        if (type === 'project') {
            screenData.projectCode = code;
        }

        this.setState({
            screenData
        })
    }

    // 搜索
    onSearch = (value) => {
        console.log(value, 'value___________');
    }

    componentDidMount() {

    }
    render() {
        const {leftTitleArr,rightProblemArr,currentIndex} = this.state;
        return (
            <>
               <LxHeader></LxHeader> 
               <div className={styles.problemCenter}>
               <div className='left-silder'>
               <Anchor offsetTop={150}>
               {
                leftTitleArr&& leftTitleArr.map((item)=>(
                    <div key={item.title} className={currentIndex === item.id ? 'currentTabs' : 'left-type-class'}
                    onClick={()=>{ 
                        document.getElementsByTagName('html') && (document.getElementsByTagName('html')[0].scrollTop = 0);
                        this.setState({
                     currentIndex: item.id
                 })
                 }}>{item.title}
                 </div>
                ))
               }
               </Anchor>
               </div>
               <div className='right-silder'>
               {
                rightProblemArr&& rightProblemArr.map((item)=>(
                    currentIndex === item.id && item.problemList.map((item,index)=>(
                        <div className='right-card-class' key={index*10}>
                            <div className="right-card-class_left">
                                <img className="problemIcon" src={problem} alt="problem"/>
                            </div>
                            <div className="right-card-class_right">
                                <div key={item.title} className="right-type-card-title">{item.title}</div>

                                <div key={item.answer}
                                     className="right-type-card-answer"
                                     dangerouslySetInnerHTML={
                                         {
                                             __html:
                                             item.answer
                                         }}
                                ></div>
                            </div>
                        </div>
                        
                    ))
                   
                ))
               }
               </div>
               </div>
            </>
        )
    }
}
export default PositionList;
